import React from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { useClient } from "../../common/ClientProvider";
import { RetentionDashboardService } from "./RetentionDashboardService";

interface RetentionDashboardServiceProviderProps {
  children: React.ReactNode;
}

export const RetentionDashboardServiceContext = React.createContext<
  RetentionDashboardService | undefined
>(undefined);

export const RetentionDashboardServiceProvider: React.FC<
  RetentionDashboardServiceProviderProps
> = ({ children }) => {
  const { getAccessTokenSilently } = useAuth0();
  const { currentClientId } = useClient();

  const service = React.useMemo(() => {
    return new RetentionDashboardService(getAccessTokenSilently, currentClientId);
  }, [getAccessTokenSilently, currentClientId]);

  return (
    <RetentionDashboardServiceContext.Provider value={service}>
      {children}
    </RetentionDashboardServiceContext.Provider>
  );
};

export const useRetentionDashboardService = (): RetentionDashboardService => {
  const context = React.useContext(RetentionDashboardServiceContext);
  if (context === undefined) {
    throw new Error(
      "useRetentionDashboardService must be used within a RetentionDashboardServiceProvider"
    );
  }
  return context;
};
